export const confirmReflectionRequestMessage = {
  confirmReflectionRequestTitle: 'Xác nhận đúng/sai YC phản ánh của khách hàng',
  confirmReflectionRequestDetailTitle: 'Xác nhận đúng sai',

  requestId: 'Mã yêu cầu',
  customerCode: 'Mã khách hàng',
  customerName: 'Họ tên KH',
  customerAddress: 'Địa chỉ KH',
  serviceType: 'Loại dịch vụ',
  requestContent: 'Nội dung yêu cầu',
  resolution: 'Kết quả xử lý',
  interpretation: 'Diễn giải',

  interpretationAchieve: 'Đạt',
  interpretationNotAchieved: 'Không đạt'
};
